import { ComponentType, JSX, PropsWithoutRef, forwardRef } from 'react';

import { Sxable } from 'library/types';

import { Draggable, DraggableProps } from './Draggable';

export interface DraggableWrapperProps extends DraggableProps, Sxable {}
type WrappedComponentProps<P extends JSX.IntrinsicAttributes> =
	ComponentType<P>;

// forwardRef left as is, since NavLink still uses it
export const withDnD = <P extends JSX.IntrinsicAttributes>(
	WrappedComponent: WrappedComponentProps<P>
) =>
	forwardRef<unknown, P & DraggableWrapperProps>(
		(
			{
				id,
				sx,
				transform,
				...propRest
			}: PropsWithoutRef<P & DraggableWrapperProps>,
			ref
		) => (
			<Draggable id={id} sx={sx} transform={transform}>
				<WrappedComponent ref={ref} {...(propRest as unknown as P)} />
			</Draggable>
		)
	);
